const rootActionPath = 'core/BonusHomeBanner';

export const BONUS_BANNER_ITEM_VIEW = `${rootActionPath}/Item/VIEW`;
